import { render, staticRenderFns } from "./index_form.vue?vue&type=template&id=8dd38902&scoped=true&"
import script from "./index_form.vue?vue&type=script&lang=js&"
export * from "./index_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd38902",
  null
  
)

export default component.exports